/** Window event that opens the chat widget from anywhere on the page */
export const OPEN_CHAT_EVENT = "bb:open-chat";
